/**
 * Quem enxerga a Carteira de projetos.
 *
 * A tela mostra a carteira da empresa inteira (saldo, faturamento e o que está
 * parado, de todos os squads), então nem todo squad deve alcançá-la. Hoje MG e
 * India ficam de fora; o admin enxerga, como no resto do sistema.
 *
 * A lista é de exclusão de propósito: squad novo passa a ver a Carteira por
 * padrão, que é o comportamento esperado — para tirar alguém, acrescente o nome
 * aqui e no `SQUADS_SEM_CARTEIRA` do backend (`carteira.controller.ts`), que é
 * quem barra de verdade.
 */
export const SQUADS_SEM_CARTEIRA = ['MG', 'India', 'Demo'];

export function podeAcessarCarteira(squadNome: string | null | undefined, isAdmin: boolean): boolean {
  if (isAdmin) return true;
  if (!squadNome) return true;
  return !SQUADS_SEM_CARTEIRA.some((s) => s.toLowerCase() === squadNome.toLowerCase());
}
